isWordPressSharePage